import {
    DialogAccount,
    DialogAccountItem,
} from 'app/shared/components/DialogAccount'
import { Button } from 'primereact/button'
import * as React from 'react'

type exItem = {
    name: string
    value: string
}
const PgDialogAccount: React.FC = () => {
    const [visible, setVisible] = React.useState(false)
    const [accounts, setAccounts] = React.useState<DialogAccountItem[]>([
        {
            pdm: '보통예금(IBK 간편한통장)',
            acn: '000-123456-01-0123',
        },
        { pdm: '보통예금1', acn: '000-123456-01-0124' },
        { pdm: '보통예금2', acn: '000-123456-01-0125' },
        { pdm: '보통예금3', acn: '000-123456-01-0126' },
        { pdm: '보통예금4', acn: '000-123456-01-0127' },
        { pdm: '보통예금5', acn: '000-123456-01-0128' },
        { pdm: '보통예금6', acn: '000-123456-01-0129' },
    ])
    const [selectedAccount, setSelectedAccount] =
        React.useState<DialogAccountItem>({ pdm: 'IBK계좌선택', acn: '' })
    //generic -----------------------------------------------------------------
    const [exVisible, setExVisible] = React.useState(false)
    const [exAccounts, setExAccounts] = React.useState<
        DialogAccountItem<exItem>[]
    >([
        {
            name: '보통예금(IBK 간편한통장)',
            value: '000-123456-01-0123',
        },
        { name: '보통예금1', value: '000-123456-01-0124' },
        { name: '보통예금2', value: '000-123456-01-0125' },
        { name: '보통예금3', value: '000-123456-01-0126' },
        { name: '보통예금4', value: '000-123456-01-0127' },
        { name: '보통예금5', value: '000-123456-01-0128' },
        { name: '보통예금6', value: '000-123456-01-0129' },
    ])
    const [selectedExAccount, setSelectedExAccount] = React.useState<
        DialogAccountItem<exItem>
    >({ name: 'IBK계좌선택', value: '' })
    return (
        <>
            <p>계좌목록 컴퍼넌트(기본)</p>
            <Button
                id="ibkSelectButton"
                onClick={() => setVisible(true)}
                className="button-basic-tint -md width-full mt-24"
            >
                <span className="txbox">
                    <span className="name">{selectedAccount.pdm}</span>
                    <strong className="number">{selectedAccount.acn}</strong>
                </span>
            </Button>
            <DialogAccount
                visible={visible}
                items={accounts}
                onSelect={(selected, items) => {
                    setSelectedAccount(selected)
                    setAccounts(items)
                }}
                onClose={() => {
                    setVisible(false)
                }}
            />
            <br />
            <br />
            <p>계좌목록 컴퍼넌트(특수)</p>
            <Button
                onClick={() => setExVisible(true)}
                className="button-basic-tint -md width-full mt-24"
            >
                <span className="txbox">
                    <span className="name">{selectedExAccount.name}</span>
                    <strong className="number">
                        {selectedExAccount.value}
                    </strong>
                </span>
            </Button>
            <DialogAccount
                visible={exVisible}
                items={exAccounts}
                onSelect={(selected, items) => {
                    setSelectedExAccount(selected)
                    setExAccounts(items)
                }}
                onClose={() => {
                    setExVisible(false)
                }}
                //----특수 일때는 필수
                titleKey="name"
                subTitleKey="value"
            />
        </>
    )
}

export default PgDialogAccount
